/**
 *
 * @authors Your Name (you@example.org)
 * @date    220-10-09
 * @version $Id$
 */
import tipsMessage from '../zh_CN/tipsMessage'

export default {
  tip_info: "暂无日语语言包，敬请期待！(已默认使用中文)",
  // tip_info: "日本語に切り替え！",
  tip_type: "success",
  welcome: '欢迎登录',
  login: '登录',
  message: {
    'hello': '你好,世界'
  },

  common: {
    total: '共',
    piece: '条',
    all: '全部', //全部
    baseInformation: '基本信息', //Base Information
    cancel: '取消', //取消
    cancelled: '已取消', //已取消
    submitted: '已提交', //已提交
    city: '市',
    close: '关闭', //关闭
    consigneeInformation: '收货人信息', //收货人信息
    copy: '复制', //复制
    custAudited: '已客审',
    delivered_or_not: '全选',
    detailed_info: '明细信息',
    details: '详情', //详情
    determine: '确定', //确定
    downloadNow: '立即下载',
    endDate: '结束日期',
    exclude_province: '排除省',
    exclude_region: '排除区域',
    financeAudited: '已财审',
    journal: '日志', //
    more: '更多', //更多
    no: '否', // 否,NO
    province: '省',
    refresh_succee: '刷新成功', //刷新成功 ,Refresh Succee
    region: '区',
    remarksInfo: '备注信息', //备注信息
    return: '返回', //返回
    reviewed: '已审核', //已审核
    searching: '检索',
    selectAll: '全选',
    startDate: '开始日期',
    tag: '标签', //标签
    tips: '提示', //提示
    to: '至', //至
    toBeReviewed: '待审核', //待审核
    unAudit: '未审核', //未审核
    voided: '已作废',
    warning: '警告', //警告
    yes: '是', //是 ,YES
    address: {
      placeName0: '杭州',
      province0: '浙江省',
      city0: '杭州市',
      erea0: '余杭区',
      addressDetails0: '良睦路999号乐佳国际大厦2号楼小邮局',
      mobile0: '13012345678',
      phone0: '057112345678',
      name: '乾宝贝最可爱',
      placeName1: '杭州',
      province1: '浙江省',
      city1: '杭州市',
      erea1: '余杭区',
      addressDetails1: '文一西路1001号阿里巴巴淘宝城5号小邮局',
      mobile1: '13012345678',
      phone1: '057112345678',
      name1: '阿里巴巴',
    },
  },

  other: {
    queryResults: '查询结果',
    fullPayment: '全部付款',
    activity_overview: '活动概览',
    addTo_original_remarks: '追加到原备注',
    basicActivity: '基础活动',
    basic_info: '基础信息',
    billCode: '账单编码',
    billTime: '账单时间',
    blessingBag: '福袋',
    color: '颜色', //颜色
    common: '普通',
    condition_info: '条件信息',
    confirmPrinting: '确定打印',
    day: '天',
    Designated_free_purchase: '指定买赠',
    download_template: '下载模版',
    downloadMethod: '下载方式',
    draft_status: '草稿状态',
    exchangeAmounts: '换货金额',
    exchangeQuantity: '换货数量', //换货数量
    fixed_settlement: '固定结算',
    gift_info: '赠品信息',
    gift_list: '赠品列表',
    gift_set: '赠品信息设置',
    goods_quantity: '商品数量',
    goods: '商品', //商品
    hour: '小时',
    info_set: '条件信息设置',
    legend: '图例',
    minute: '分钟',
    myMission: '我的任务', //我的任务
    newWarehouse_change: '新增仓库改仓',
    no_double: '不翻倍',
    noDataAvailable: '暂无数据',
    offline_expired_status: '下线/过期状态',
    offline_expired: '下线/过期',
    orderState: '订单状态',
    originalWarehouseOutOfStock_change: '原仓缺货改仓',
    otherAmounts: '其他金额', //其他金额
    override_original_remarks: '覆盖原备注',
    participating_goods: '参与商品',
    payment_date: '付款日期',
    platformDelivery: "平台发货", //平台发货
    postage_compensation: '邮费赔付',
    postage: '邮费',
    price_compensation: '价格赔付',
    printing: '打印',
    product_list: '商品列表',
    product_related_info: '商品相关信息',
    piece: '件',
    refundablePostage: '应退邮费', //应退邮费
    refundAmountGoods: '商品应退金额',
    refundNumber: '退单号',
    returnGood: '退货',
    sales_price: '销售价',
    sendAll: '全部送',
    settlementAmountConsignment: '代销结算金额', //代销结算金额
    shop: '店铺', //店铺
    simulation_order_setup: '模拟订单设置',
    size: '尺码',
    sizes: '尺寸', //尺寸
    submission_status: '提交状态',
    systemCommodity_SKU: '系统商品SKU',
    systemNotes: '系统备注', //系统备注
    systemVoid: '系统作废', //系统作废
    sysWrongJudgment_change: '系统错判改仓',
    toBeDelivered: '待发货',
    total: '合计', //合计
    totalAmountReturnOrder: '退货单总金额', //退货单总金额
    trialCalculation_results: '试算执行结果',
    unlimited: '不限制',
    upload_files: '上传文件',
    uploadVoucher: '上传凭证', //上传凭证
    view_log: '查看日志',
    warehouseDelivery: "仓库发货", //仓库发货    
    nonMatchingGoods: '非搭配商品', // 非搭配商品
    preSale: '预售', // 预售
    depositTime: '定金时间', // 定金时间
    buyAndGive: '全场买赠', // 全场买赠
    excludeFollowingItems: '排除以下商品', // 排除以下商品
    outOfStock: '缺货',
    RefundSuccessful: '退款成功',
    payType: '支付类型',
    auditError: '审核失败',
    multipleOutOfStock: '多次缺货',
    manual: '手动',
    noDefectiveProductAllocation: '无次品调拨',
    defectiveProductsAllocated: '次品已调拨',
    defectiveProductsNotAllocated: '次品未调拨',
    platForm: '平台',
    warehousingLogicalWarehouse: '入库逻辑仓库',
  },

  btn: {
    forceMatching: '强制匹配',
    searchReturnOrder: '查询退单',
    clearReturnOrder: '清除退单',
    previous: '上一步',
    next: '下一步',
    authorityYes: '授权成功',
    authorityNo: '授权失败',
    addDetail: '新增明细',
    deleteDetail: '删除明细',
    markCancel: '标记取消',
    preSaleBalancePaid: '预售尾款已付',
    nonPreSale: '非预售',
    cashOnDelivery: '货到付款',
    add_collocation: '添加搭配',
    add_ladder: '添加阶梯',
    add: '新增', //新增
    addGift: "添加赠品", //添加赠品
    additionalRefund: '额外退款', //额外退款
    add_splitOrder: '添加到待拆单', //添加到待拆单
    afterSalesAudit: '售后审核', //售后审核
    appointGoods_splitOrder: "指定商品拆单", //指定商品拆单
    audit: '审核', //审核
    back: '返回',
    batch_add: '批量新增', //批量新增
    batch_chargeback: "批量退单", //批量退单
    batch_holdOrder: '批量Hold单', //批量Hold单
    batchModify_logistics: '批量修改物流', //批量修改物流
    batchModify_remarks: '批量修改备注', //批量修改备注
    batchModify_warehouse: '批量修改仓库', //批量修改仓库
    batchModify: '批量修改',
    batchModifyGoods: "批量改商品", //批量改商品
    batchOriginalReturn: '批量原退', //批量原退
    batchSplitOrder: "批量拆单", //批量拆单
    batch_addGift: "批量添加赠品", //批量添加赠品
    batch_deleteGift: "批量删除赠品", //批量删除赠品
    batch_replaceGoods: "批量替换商品", //批量替换商品
    beOut_of_stock: '缺货重新占单', //缺货重新占单
    copyPermissions: '复制权限',
    cancel_automaticRefund: '取消自动退款', //取消自动退款
    cancel_mergeOrders: "取消合并订单", //取消合并订单
    cancelBlocking: '取消拦截', //取消拦截
    cancelHold: '取消Hold', //取消Hold
    batch_cancelHold: '批量取消Hold', //批量取消Hold
    changeAddress: '修改地址', //修改地址
    changeTo_platformShipment: "更改为平台发货", //更改为平台发货
    collection: "收藏", //收藏
    copyOrder: "复制订单", //复制订单
    confirm_splitOrder: "确认拆单", //确认拆单
    createOrder: '创建订单', //创建订单
    custAudit: '客审',
    dealInOrder_download: '经销订单下载',
    deAudit: '反审核', //反审核
    deCustAudit: '反客审',
    delete_collocation: '删除搭配',
    delete_ladder: '删除阶梯',
    delete: '删除',
    deleteGift: "删除赠品", //删除赠品
    distributionChargeback_download: '分销退单下载',
    distributionOrder_download: '分销订单下载',
    distributionProduct_download: '分销商品下载',
    download: '下载',
    downloadProgressBill: '进度账单下载',
    draft: '草稿',
    empty: '清除', //清除
    expedited_shipment: '加急发货', //加急发货
    export: "导出", //导出
    financeAudit: '财审',
    find: '查找',
    forcedStorage: '强制入库',
    fubaoOut_of_stock: '福袋缺货重新占单', //福袋缺货重新占单
    generalGoods_download: '通用商品下载',
    generalOrder_download: '通用订单下载',
    generate: '生成',
    giftDelivery_copy: "赠品出库复制", //赠品出库复制
    holdOrder: 'Hold单', //hold单
    import: "导入", //导入
    increase: "添加", // 添加
    invoiceNotice: '开票通知', //开票通知
    lostOrder_copy: '丢单复制', //丢单复制
    mandatoryCompletion: '强制完成', //强制完成
    manual_matching: '手工匹配',
    manualCreation: '手工创建', //手工创建
    manualMarking: '手工打标', //手工打标
    mark_efective_product_transferred: '标记次品已调拨',
    mergeOrders: "合并订单", //合并订单
    missedCopy: "漏发复制", //漏发复制
    modify_logistics: '修改物流',
    modify_returnWarehouse: '修改退回仓库', //修改退回仓库
    modify: '修改', //修改
    modifyRemarks: '修改备注', //修改备注
    modifyWarehouse: '修改仓库', //修改仓库
    modify_sellerNotes: '修改卖家备注', //修改卖家备注
    monthlyBillDownload: '月结账单下载',
    new_chargeback: '新增退单', //新增退单
    new_workOrder: '新增工单', //新增工单
    note_import: '备注导入', //备注导入
    offline: '下线',
    orderBlocking: '订单拦截', //订单拦截
    orderCancel: '订单取消', //订单取消
    original_single_null_and_void_copy: "原单无效复制", //原单无效复制
    out_of_stock_splitOrder: "缺货拆单", //缺货拆单
    overdue: '过期',
    order_detailed: '订单明细', //订单明细
    publish: '发布',
    published: '已发布',
    preSaleAdvanceDeliveryMarking: '定金预售提前发货打标', //定金预售提前发货打标
    query: '查询',
    rark_refundComplete: '标记退款完成',
    recordInvoice: '记录发票', //记录发票
    refresh: '刷新',
    release_inventory: "释放库存", //释放库存
    replaceGoods: "替换商品", //替换商品
    changeGoods: '更换商品',
    reset: '重置',
    retransmission_WMS: '重传WMS', //重传WMS
    returnCopy: '退换货复制', //退换货复制
    save: '保存',
    saveDraft: '保存草稿',
    search: '搜索', //搜索
    sellerNotesImport: '卖家备注导入', //卖家备注导入
    set_groups: '设置分组',
    cancel_groups: '取消分组',
    simulation_trial_calculation: '仿真试算',
    simulation: '模拟仿真',
    splitOrder: '拆分订单', //拆分订单
    sortForm: '排序表单', //排序表单
    text: '按钮',
    virtualWarehous: '虚拟入库', //虚拟入库
    void: '作废',
    wrong_sending_forced_matching: '错发强制匹配',
    wrongCopy: "错发复制", //错发复制    
    show: '显示',
    hide: '隐藏',
  },

  pHolder: {
    a0: '（为空不做控制，关键字依次填写，用中文“；”隔开）',
    a1: '选择日期范围',
    a2: '请输入用户名',
    a3: '请输入密码',
    a4: '输入后请按Enter',
    a5: '',
    a6: '',
    a7: '',
    a8: '',
    a9: '',
    aa: '',
    chargebackNumber: '请输入退单编号',
    consignee: '请输入收货人',
    enter: '请输入', //请输入 ,Please enter
    organizationCode_or_name: '请输入机构编码或名称', //请输入机构编码或名称,Please enter the organization code or name
    phone_number: '请输入手机号码',
    userName: '用户名', //用户名,User name
    z0: '多个平台单号，用逗号分隔',
    z1: '请输入平台单号',
    z2: '请选择订单状态',
    z3: '多个退供单号，用逗号隔开',
    z4: '请输入商品SKU',
  },

  panel_label: { // 面板title
    a0: '退货单',
    a1: '退换货单',
    a2: '退换货单详情',
    a3: '退单编号查询',
    a4: '等待出库',
    a5: '换货待发货',
    a6: '分仓规则编辑',
    a7: '商品明细',
    a8: '创建内容',
    a9: '入库单结单',
    aa: '创建条件',
    ab: '按未拣货数创建',
    ac: '入库单',
    ad: '拣货单',
    ae: '执行动作',
    af: '',
    aj: '',
    ah: '',
    ai: '',
    aj: '',
    ak: '',
    al: '',
    am: '',
    an: '',
    ao: '',
    ap: '',
    aq: '',
    ar: '',
    as: '',
    at: '',
    au: '',
    av: '',
    aw: '',
    ax: '',
    ay: '',
    az: '',
    edit_order_dispatch_rule: '订单派单规则编辑',
    add_claimForm: '赔付单新增', // 赔付单新增,Add ClaimForm
    add_retail_shipping_order: '零售发货单新增', //零售发货单新增
    addPromotion: '新增促销活动',
    addReturnOrder: '退换货订单新增', //退换货订单新增
    all: '全部',
    barCode_details: '条码明细',
    basicData: '基础资料', //基础资料
    batchAddPromotion: '批量新增促销活动',
    billingNoticeEdit: '开票通知编辑', //开票通知编辑
    brand_authority: '品牌权限', //品牌权限，Brand authority,
    combinedCommodity_details: '组合商品明细',
    combinedCommodity_edit: '组合商品档案编辑',
    combinedCommodity: '组合商品档案',
    commodity_authority: '商品权限', //商品权限,Commodity authority
    company_authority: '公司权限', //公司权限,Company authority
    details_claimForm: '赔付单详情', // 赔付单详情
    distributionCenter_authority: '配销中心权限', //配销中心权限，Distribution center authority,
    editPromotion: '编辑促销活动',
    enterInfo: '录入信息', //录入信息
    exchangeInfo: '换货人信息', //换货人信息
    express_compensation_scheme: '快递赔付方案',
    extraRefundEdit: '额外退款编辑', //额外退款编辑
    forcedStorage: '退换货订单', //退换货订单
    generate_replacement_order: '是否生成换货单',
    interface_download_taskTable_edit: '接口下载任务表编辑',
    interface_download_taskTable: '接口下载任务表',
    log: '日志',
    logisticsAreaSetting: '物流区域设置', //物流区域设置
    operationLog: '操作日志', //操作日志
    order_detailed: '订单明细', //订单明细
    orderManager_edit: '订单管理编辑', //订单管理编辑
    orderManager: '订单管理', //订单管理
    orderSplit: '订单拆分', //订单拆分
    payableAdjust_details: '赔付单明细', //赔付单明细
    payableAdjustmentList: '赔付单', //赔付单
    promotionList: '促销活动',
    refundSlipDetails: '退款单详情',
    retailInvoice_details: '零售发货单详情', //零售发货单详情
    retail_shipping_order: '零售发货单', // 零售发货单
    return_warehousing_manual_matching: '退货入库-手工匹配',
    return_warehousing_wrong_delivery_forced_matching: '退货入库-错发强制匹配',
    returnAmount: '退货金额', //退货金额
    returnAndExchange_info: '退换货信息', //退换货信息
    ReturnOrderDetails: '退换货订单详情', //退换货订单新增
    returnTreasury: '退货入库',
    returnTreasuryAdd: '退货入库新增',
    returnTreasuryDetails: '退货入库详情',
    role_authority: '角色权限', //角色权限,Role authority
    scanDetails: '扫描明细', //扫描明细
    scanInfo: '扫描信息', //扫描信息
    scannAndWarehous: '扫描入库', //扫描入库
    setWarehouseLogistics: '仓库物流优先级设置',
    supplier_authority: '供应商权限', //供应商权限,Supplier authority
    vipshopWarehouseEntry: '唯品会入库单',
    warehouse_authority: '店仓权限', //店仓权限,Warehouse authority'
    warehouse_logistics_priority_scheme: '仓库物流优先级方案',
    warehouse_receipt: '出仓单',
    JITchangeBrand: 'JIT配货单换吊牌',
  },

  form_label: { // 检索表单label
    a0: '收货地址就近',
    a1: '唯品会',
    a2: '仓库优先级',
    a3: '发货比例',
    a4: '发货数量',
    a5: '按收货地址',
    a6: '派单规则明细',
    a7: '分仓比例',
    a8: '杭州店仓',
    a9: '计算虚高库存前库存',
    aa: '省市区',
    ab: '详细地址',
    ac: '非赠品',
    ad: '应退运费',
    ae: '最终应退总金额',
    af: '发货实体仓',
    ag: '平台状态',
    ah: '订单金额',
    ai: '商品总金额',
    aj: '订单总金额',
    ak: '实付金额',
    al: '红包',
    am: '代收COD金额',
    an: '多包裹',
    ao: '服务单号',
    ap: '店铺授权',
    aq: '店铺昵称',
    ar: '完善信息',
    as: '授权有效时间',
    at: '卖家姓名',
    au: '所在省',
    av: '所在市',
    aw: "所在区\县",
    ax: '卖家地址',
    ay: '授权指引',
    az: '添加排除区域',
    b0: '切换为sku商品显示',
    b1: '切换为平台商品明细',
    b2: '零售价合计',
    b3: '商品优惠',
    b4: '订单优惠金额',
    b5: '支持省份',
    b6: '排除省份',
    b7: '删除区域',
    b8: '支持范围',
    b9: '申请时间',
    ba: '商品数字ID',
    bb: '省市搜索',
    bc: '策略ID',
    bd: '策略名称',
    be: '生效开始时间',
    bf: '生效结束时间',
    bg: '启用状态',
    bh: '最低成交单价',
    bi: '识别规则',
    bj: '支付时间',
    bk: '主播ID',
    bl: '主播昵称',
    bm: '订单标签',
    bn: '“播”标',
    bo: '日程规划名称',
    bp: '规划开始时间',
    bq: '规划结束时间',
    br: '补货独立入库',
    bs: '唯品会仓库',
    bt: '拣货单类型',
    bu: '未拣货数维度',
    bv: '',
    bw: '',
    bx: '',
    by: '',
    bz: '',
    type: '类型',
    ruleName: '规则名称',
    aconsignee_address: '收货人地址',
    aconsignee_area: '收货人区', //收货人区,
    activityDate: '活动日期',
    activityName: '活动名称',
    activityType: '活动类型',
    actualRefundAmount: '实际退款金额', //实际退款金额
    addressee_phone: '收件人手机', //收件人手机
    addressee: '收件人', //收件人
    adjustmentType: '调整类型',
    adjustEndTime: '调整结束时间', //调整结束时间
    apply_refundAmount: '申请退款金额',
    autoMatch: '是否自动匹配', //是否自动匹配
    automaticRelease: '自动释放',
    bankAccountNo: '开户行账号',
    bankOFdeposit: '开户银行',
    bar_code_does_not_match: '鞋盒条码与实物条码不符', //鞋盒条码与实物条码不符
    barCode: '条码', //条码
    bar_code: '条码编码',
    batchNumber: '批次号',
    batch_number: '批次编号',
    billing_status: '开票状态',
    billNo: '单据编号',
    billStatus: '单据状态',
    billType: '单据类型',
    buyer_HOLD: '买家HOLD单',
    buyer_message: '买家留言',
    buyerNotes: '买家备注', //买家备注
    BuyerPhoneNumber: '买家手机号', //买家手机号
    cellPhone_number: '手机号',
    changeOrderModify_time: '换货单修改时间',
    changeOrderStatus: '换货单状态',
    changeWarehouse_reasons: '改仓原因',
    channelType: '渠道类型', //
    chargebackModifyTime: '退单修改时间',
    chargebackNumber: '退单编号', //退单编号
    chargebackStatus: '退单状态',
    choose_product_ways: '选择商品方式',
    closingMan: '结案人',
    closingTime: '结案时间',
    collection_amount: '代收金额', //代收金额
    combinedCommodityType: '组合商品类型',
    commodityCode: '商品条码',
    commodityID: '商品ID',
    companyAddress: '公司地址',
    complete: '完成',
    confirmed_as_JITX: '确认为JITX',
    confirmed_as_non_JITX: '确认为非JITX',
    confirming: '确认中',
    consignee_city: '收货人市', //收货人市
    consignee_phone: '收货人手机', //收货人手机
    consignee_postcode: '收货人邮编', //收货人邮编
    consignee_province: '收货人省份', //收货人省份
    consignee_tel: '收货人电话', //收货人电话
    consignee: '收货人', //收货人
    contactNumber: '联系电话', //联系电话
    create_and_download: '创建并下载拣货单',
    creationDate: '创建日期', //
    current_remarks: '当前备注:',
    custAuditDate: '客审日期', //
    defectiveProduct_allocation_status: '次品调拨状态',
    defectiveProductRecord: '次品记录',
    deliverGoodsAddress: '发货地址', //发货地址
    delivery_warehouse: '发货仓库', //发货仓库
    depositOrderNo: '押金订单号',
    distribution_costs: '配送费用', //配送费用
    distribution_logistics: '配送物流', //配送物流
    distributionMode: '配送方式',
    documentDate: '单据日期', //单据日期
    double_gifts: '赠品翻倍',
    downloadOnly: '仅下载拣货单',
    downloadType: '下载类型',
    delayDate: '延期日期',
    effectiveDate: '生效日期',
    electronic_invoice: '电子发票',
    endDate: '结束日期',
    endTime: '结束时间',
    enterprise: '企业',
    exchangeDetails: '换货明细',
    exchangePending: '换货待处理',
    exchangePlatform_no: '换货平台单号',
    exchangePostage: '换货邮费',
    expressCompanyName: '快递公司名称', // Name of express company
    expressOutlets: '快递网点', //
    financeAuditDate: '财审日期', //
    free_quantity: '赠送数量',
    freight: '运费', //
    fullName: '姓名',
    gBCode: '国标码',
    gift: '赠品',
    giving_ways: '赠送方式',
    goods_participation_mode: '商品参与方式',
    goods_source: '商品来源',
    goodsMark: '商品标记', //商品标记
    goodsName: '商品名称', //商品名称
    goodsPID: '商品PID',
    gradient_gift: '梯度赠送',
    handler: '处理人',
    hOLD_reason: 'HOLD单原因',
    identificationNo: '识别号',
    in_order_stockNo: '入库单单号',
    in_warehouse: '入库仓库',
    internalRemarks: '内部备注', //内部备注
    invoice_or_not: '是否开票', //是否开票
    invoice_remarks: '发票备注',
    invoice_type: '发票类型',
    invoiceTitle_type: '抬头类型',
    invoiceTitle: '发票抬头',
    is_there_no_original_barcode: '是否无原单条码', //是否无原单条码
    issueBarcode: '发出条码', //发出条码
    ladderType: '阶梯类型',
    live_HOLD: '直播HOLD单',
    logic_warehouse: '逻辑仓库',
    logisticsCompany: '物流公司',
    logisticsNo: '物流编号',
    logisticsOrder_No: '物流单号', //物流单号
    lotType: '批次类型', //批次类型
    mailbox: '邮箱',
    match_smart_address: '智能匹配地址', //智能匹配地址
    max_doubling_times: '最大翻倍次数',
    max_times: '最大次数',
    meet_conditions: '满足条件',
    modify_remarks: '修改备注:',
    multiple: '倍数',
    namePayee: '收款人姓名', //收款人姓名
    newlyBuild: '新建',
    normal: '正常', //正常
    numberCode: '数字编号',
    offline_stores: '线下门店',
    offlineTime: '下线时间',
    one_participation_times: '单个买家参与活动次数',
    operator: '操作人',
    order_notes: '订单备注',
    orderNumber: '订单号', //订单号
    orderShop: '下单店铺', //下单店铺
    orderType: '订单类型',
    order_time: '订单时间',
    out_date: '出库日期',
    original_out_date: '原始出库日期', //
    originalDeliveryWarehouse: '原发货仓',
    originalOrder_No: '原单单号', //原单单号
    originalOrderNo: '原始订单编号', //原始订单编号
    originalOrderPlatform: '原平台单号', //原平台单号
    originalPlatformNo: '原始平台单号', //原始平台单号
    ownership: '日程归属',
    paper_invoice: '纸质发票',
    payableAdjustReason: '赔付原因',
    payableAdjustStandard: '赔付标准',
    payableAdjustType: '赔付类型', //
    payment_info: '支付信息', //支付信息
    paymentMethod: '付款方式', //付款方式
    personal: '个人',
    phone_number: '手机号码', //手机号码
    physicalWarehouseFile: '实体仓档案',
    physicalWarehouseName: '实体仓名称',
    pickingOrder_no: '拣货单号',
    platform_billNo: '平台单号',
    platform_marking: '平台标记',
    platform_returnOrder_no: '平台退货单号',
    platformCommodityID: '平台商品ID',
    platformExchangeOrder_no: '平台换货单号',
    PlatformModifyTime: '平台修改时间',
    platformProductsCode: '平台商品编码',
    platformProductsName: '平台商品名称',
    platformRefundNo: '平台退款单号',
    platformTime: '平台时间',
    platformType: '平台类型',
    preferential_info: '优惠信息', //优惠信息
    price: '价格',
    processor_remarks: '处理人备注',
    promotion_status: '促销状态',
    processing_status: '处理状态',
    promotionNo: '促销编号',
    proReturnStatus: '退货状态',
    purchase_ranking: '购买排名',
    purchaseQuantity: '购买数量', //购买数量
    qualityGoods: '正品', //正品
    queryTime: '查询时间',
    orderTime: '下单时间',
    reasonRefund: '退款原因', //退款原因
    receiptAddress: '收票地址',
    receivedBarcode: '实收条码', //实收条码
    receivedGBcode: '实收国标码', //实收国标码
    receiver_mobileNo: '收货人手机号',
    receiving_province: '收货省份',
    refundAmount: '退款金额', //退款金额
    refundClass: '退款分类', //退款分类
    refundDescription: '退款描述', //退款描述
    refundNoteDelivered: '已发货退款单', //已发货退款单
    refundOnly: '仅退款',
    refundType: '退款类型',
    region_details: '区域明细',
    release_after_fixedTime: '固定时长后释放',
    release_specified_timePoint: '指定时点释放',
    release_timePoint: '释放时点',
    remarks_content: '备注内容',
    remarksResponsibleParty: '判责方备注', //判责方备注
    reservedStockExchange: '换货预留库存',
    responsibleParty: '判责方', //判责方
    returnBatch: '退货批次', //退货批次
    returnDetails: '退货明细',
    returnLogisticsCompany: '退回物流公司', //退回物流公司
    returnLogisticsNumber: '退回物流单号',
    returnNo: '退供单号',
    returnNotes: '退换货备注', //退换货备注
    returnOrder_no: '退换货单号', //退换货单号
    returnOrderLog: '退货单日志',
    returnQuantity: '退货数量', //退货数量
    returnRefund: '退货退款',
    returnInformation: '返回信息',
    reviewer: '审核人',
    routing_info: '路由信息', //路由信息
    salesReturn_to_warehouse: '销退入库仓', //销退入库仓
    scansNumber: '扫描数量', //扫描数量
    scheduleOwnership: '档期日程归属',
    schemeDescription: '方案描述',
    schemeName: '方案名称',
    sellerNotes: '卖家备注', //卖家备注
    sending_address: '发件地址',
    service_charge: '服务费', //服务费
    settlement_price: '结算价',
    shipPhysicalWarehouse: '发货实体仓库',
    shipping_info: '发货信息', //发货信息
    skuName: 'SKU名称', //SKU名称
    source_billNo: '来源单据编号',
    sourceDocuments: '单据来源', //单据来源
    sourceNo: '来源单号',
    special_invoice: '专用发票',
    specialTreatmentType: '特殊处理类型', //特殊处理类型
    specs: '规格', //规格
    status_in_warehouse: '仓内状态', //仓内状态
    startTime: '开始时间', //开始时间
    staySellerAgrees: '待卖家同意',
    store: '门店', //门店
    storeID: '店铺ID',
    supplierID: '供应商ID',
    synchronizationStatus: '同步状态',
    synchronizedInventory: '同步库存数',
    telephoneNumber: '电话号码',
    ticket_info: '收票信息',
    timeRange: '时间范围',
    timeType: '时间类型',
    transactionAmount: '成交金额', //成交金额
    transportationMode: '运输方式',
    undeliveredCancel: '未发货取消',
    ungraded: '次品', //次品
    virtual_barcode: '虚拟条码',
    waitFor_afterSale_confirm: '等待售后确认', //等待售后确认
    waitFor_afterSale_review: '等待售后审核', //等待售后审核
    waitFor_return_warehous: '等待退货入库', //等待退货入库
    warehouse: '仓库',
    warehousingEntity: '入库实体仓库',
    whether_returned: '是否原退', //是否原退
    wMS_billNo: 'WMS单据编号',
    workOrder: '工单', //工单
    wrongOrNot: '是否错误',
    payAccount: '支付账号',
  },

  table_label: { // 表头、表脚、表统计
    itemNo01: 'SPU编码',
    itemNo02: 'SPU名称',
    a0: '期初可售数',
    a1: '变化数量',
    a2: '期末可售数',
    a3: '日程归属名称',
    internationalCode: '国际码',
    abbreviation: '简称',
    abnormalInfo: '异常信息', //异常信息
    activity_period: '活动时间段',
    actual_barcode: '实际发出条码',
    actual_transactionPrice: '实际成交价',
    add_manually: '是否手工新增',
    adjustment_amount: '调整金额', //调整金额
    aequenceNo: '顺序号',
    after_modification: '修改后',
    alipay: '支付宝号',
    amountDue: '应付金额',
    appleNumber: '申请数量', //申请数量
    articleNumber: '货号',
    auditTime: '审核时间', //审核时间
    before_modification: '修改前',
    brand: '品牌', //品牌 ,brand
    buyerNickname: '买家昵称', //买家昵称
    check_mainStore: '查看主店仓', //查看主店仓 ,Check the main store
    code_SKU: 'SKU编码',
    code: '编码',
    commodityDataNo: '商品数据编号',
    commoditySKU: '商品SKU',
    companyCode: '公司编码', //公司编码 ,Company code
    companyName: '公司名称', //公司名称 ,Company name
    compensation_expressCompany: '赔付快递公司',
    creationTime: '创建时间', //创建时间
    creator: '创建人',
    custAuditMan: '客审人',
    custAuditTime: '客审时间', //
    custName: '顾客姓名',
    custTelephone: '顾客电话',
    discount: '折扣',
    delivered_quantity: '已送数量',
    deliveryWarehouse_code: '发货仓库编码',
    deliveryWarehouse_name: '发货仓库名称',
    description: '说明', //说明 ,Description
    distribution_amount: '分销金额',
    distributionCenterCode: '配销中心编码', //配销中心编码 ,Distribution Center Code
    distributionCenterName: '配销中心名称', //配销中心名称 ,Distribution Center Name
    distributionTime: '配货时间', //配货时间
    edit: '编辑', //编辑 ,edit
    equal_amount: '平摊金额',
    exchangeQuantity: '换货数量', //换货数量
    expressCode: '快递编码',
    expressCompany: '快递公司',
    expressName: '快递名称',
    expressNo: '快递单号',
    extendedProperties: '扩展属性',
    failure_offline_time: '失效下线时间',
    financeAuditMan: '财审人',
    financeAuditTime: '财审时间', //
    flag: '旗帜', //旗帜
    gender: '性别', //性别
    generate_adjustment: '是否生成调整单',
    generate_error_adjustment: '是否生成错发调整单',
    generate_punching_headless_adjustment: '是否生成冲无头件调整单',
    generate_stock: '是否生成入库单',
    giftItemCode: '赠品商品编码',
    giftItemName: '赠送商品名称',
    given_total_quantity: '赠送总计数量',
    goodsInfo: '商品信息', //商品信息
    grouping: '分组',
    groupName: '分组名称',
    in_warehouse_goods_details: '入库单商品明细',
    itemNo: '商品款号',
    logContent: '日志内容',
    logicWarehouse: '逻辑仓',
    mainStore_warehouse: '制单主店仓', //制单主店仓 ,Main store warehouse
    match_or_not: '是否匹配',
    materialShortage: '实物报缺',
    modificationTime: '修改时间',
    new_address: '新地址',
    new_detailed_address: '新详细地址',
    new_receivingInfo: '新收货信息',
    no_original_barcode: '是否无原单条码',
    number_of_rows_per_group: '每组抽取行数',
    operation_description: '操作描述',
    operation: '操作',
    operatorName: '操作姓名',
    operatorTime: '操作时间',
    orderIdentification: '订单标识',
    orderNo: '订单编号',
    orderQuantity: '订单数量',
    orderTime: '下单时间', //下单时间
    original_deliveryWarehouse: '原发货仓库', //原发货仓库
    original_groupName: '原分组名称', //原分组名称
    outOfStock_quantity: '缺货数量',
    participating_stores: '参与店铺',
    payable_unitPrice: '应付单价',
    paymentTime: '付款时间', //付款时间
    paymentWay: '支付方式',
    per_given_quantity: '每次赠送数量',
    physical_warehouse: '实体仓库',
    physicalWarehouse: '实体仓',
    platform_barcode_ID: '平台条码ID',
    platform_model_ID: '平台款号ID',
    platform_orderNo: '平台单号', //平台单号
    platformInfo: '平台信息', //平台信息
    platform_store_title: '平台店铺标题',
    preferential_amount: '优惠金额', //优惠金额
    priority: '优先级',
    product_title: '商品标题',
    productName: '商品名称', //商品名称 ,Product Name
    productNo: 'SPU编码', // SPU编码,Product Number
    productSKUname: '商品SKU名称',
    promotionName: '促销名称',
    quantities: '数量',
    quantity_availableSale: '可售数量',
    quantity_demolished: '待拆数量',
    quantity_split: '拆分数量',
    receivingInfo: '收货信息', //收货信息
    refund_status: '退款状态',
    remarks: '备注',
    replicationReason: '复制原因', //复制原因
    rest_sent: '剩余可送',
    return_warehousing_log: '退货入库日志',
    returnGood: '退货',
    returnGoods: '退换货',
    revised_content: '修改内容',
    reviser: '修改人',
    roles: '角色', //角色 ,Roles
    rows: '行', //行 ,ROWS
    scanDeliveryTime: '扫描出库时间', //扫描出库时间
    seller_nickname: '卖家昵称',
    sensitiveColumn: '敏感列', //敏感列 ,Sensitive column
    serialNo: '序号', //序号 ,No
    settlementAmount: '结算金额',
    shippingAddress: '收货地址', //收货地址
    shopName: '店铺名称',
    standardPrice: '标准价',
    status: '状态',
    stock: '库存',
    storageQuantity: '入库数量',
    storehouse: '店仓', //店仓 ,Storehouse
    supplier_fullName: '供应商全称', // 供应商全称,Supplier's full name
    supplierCode: '供应商编码', //供应商编码 ,Supplier Code
    supplierName: '供应商名称', // 供应商名称,Supplier name
    suggested_deliveryWarehouse: '建议发货仓库', // 建议发货仓库
    tagPrice: '吊牌价', //吊牌价
    total_amountDue: '总应付金额',
    total: '总计', //总计 ,TOTAL
    totalOrderAmount: '订单总额', //订单总额
    totalSettlement: '结算总额',
    transactionAmount: '成交金额', //成交金额
    turnOff_match: '是否关闭匹配',
    unitPrice: '成交单价',
    unitPriceSettlement: '结算单价',
    unitReturnAmount: '单件退货金额',
    usable: '可用',
    view: '查看', //查看 ,view
    vip_nickname: '会员昵称',
    voidMan: '作废人',
    voidTime: '作废时间',
    warehouseName: '仓库名称',
    warehouseNo: '仓库编号',
    whetherGift: '是否赠品', //是否赠品
  },

  modalTitle: { // 弹窗title
    aa: '清除失败提示框',
    ab: '分仓策略-导入',
    th1: "替换前商品",
    th2: "替换后商品",
    a0: '店铺商品特殊设置明细', // 店铺商品特殊设置明细
    a1: '被替换商品SKU', // 被替换商品SKU
    a2: '批量新增条件信息导入', // 批量新增条件信息导入
    a3: '请选择仓库',
    a4: '替换后商品SKU',
    a5: '报错信息',
    a6: '提示信息',
    a7: '弹框多选',
    a8: '提示框',
    a9: '匹配失败提示框',
    // * 看开始的地方 aa…… 在上面
    add_adjustmentListDetails: '新增应付调整单明细', // 新增应付调整单明细
    batchImport: '批量导入', //批量导入
    blacklist: '加入黑名单', //加入黑名单
    data: '数据', //数据
    deleteDetails: '删除明细', //删除明细
    error: '错误', // 错误
    import: '导入', //导入 ,IMPORT
    manualWarehous: '手动入库', //手动入库
    matrixEntry: '矩阵录入', //矩阵录入
    modify_logisticsCompany: '修改物流公司', //修改物流公司
    modify_returnWarehouse: '修改退货仓库', //修改退货仓库
    modify_sellerNotes: '修改卖家备注', //修改卖家备注
    modify_shipping_address: '修改收货地址', //修改收货地址
    newReturnDetails: '新增退货明细', //新增退货明细
    orderDownload: '订单下载', // 订单下载
    originalChargebackDetails: '原始退单明细', // 原始退单明细
    query_OriginalOrderNo: '查询原始订单编号', // 查询原始订单编号
    select_logisticsCompany: '请选择物流公司', // 请选择物流公司
    sortForm: '排序表单', //排序表单
    tips: '提示', //提示 ,TIPS
    title: '标题', // 标题
    warning: '警告', //警告 ,WARNINGRNING
    postpone: '延期', //延期
    z0: '库存按查询条件同步', // 库存按查询条件同步
    z1: '商品按查询条件同步', // 商品按查询条件同步
  },

  modalTips: tipsMessage,
}
